<template>
  <el-container>
    <el-header>
      <h2>ChangeLog 更新日志</h2>
      <el-button @click="backWorkbech">返回控制台</el-button>
    </el-header>
    <el-main>
      <el-timeline>
        <el-timeline-item
            v-for="(item) in changelogContent"
            :key="item.content"
        >
          <span>{{item.content}}</span>
          <el-card>
            <h4>更新 Github 模板</h4>
            <p>王小虎 提交于 2018/4/12 20:46</p>
          </el-card>
        </el-timeline-item>
      </el-timeline>
    </el-main>
  </el-container>
</template>

<script>
export default {
  name: 'helpCenterNotice',
  data() {
    return {
      changelogContent: [
        {
          content: '1.1.0   2018-04-12',
        },
      ],
    };
  },
  methods: {
    backWorkbech() {
      this.$router.push('/workbench');
    },
  },
};
</script>

<style scoped lang="scss">
.el-container {
  height: 100%;
  background-color: #fff;
  padding: 18px;
}
.el-button {
  width: 128px;
  height: 40px;
  background-color: #0052D9;
  color: #FFFFFF;
}
.el-header {
  display: flex;
  justify-content: space-between;
  height: 40px !important;
  padding: 0 0 0 46px;
}
.el-main {
  padding: 40px 0 0 46px;
}

.el-timeline {
  text-align: left;
}
.el-timeline-item {
  ::v-deep .el-timeline-item__tail {
    border-left: 1px solid #3E66C3;
    left: 2px;
    top: 10px;
    height: calc(100% - 16px);
  }
  ::v-deep .el-timeline-item__node {
    background: #fff;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    border: 1px solid #3E66C3;
    left: 0;
  }
}

</style>
